let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j1eUL")).then(() => parcelRequire('5KSuP'));